import React from 'react'
import Places from '../../organisms/Placessections/Places'
import Mapsection from '../../organisms/Homesections/Mapsections/Mapsection'
import Footer from '../../organisms/Footersections/Footer'
import { useTranslation } from 'react-i18next'

export default function Placespage() {
  const { i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  const mapLink = isArabic
    ? "https://egcapitalgis.idsc.gov.eg/portal/apps/webappviewer/index.html?id=e88677173bce482e94b46d1ee2ae8d32&locale=ar"
    : "https://egcapitalgis.idsc.gov.eg/portal/apps/webappviewer/index.html?id=a91aa740f662488182a85dc2c8b0f2f6"

  return (
    <div className="bg-rd-500">
      <Places></Places>
      <div className="bg-re-500">
      <Mapsection mapLink={mapLink} height={'md:h-[700px]'}/>
      </div>
      <div>
      <Footer/>
      </div>
    </div>
  )
}


